module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"list":{"series":"バージョン","name":"曲名","artist":"アーティスト","bpm":"BPM","noData":"データがありません"}},"en":{"list":{"series":"Version","name":"Name","artist":"Artist","bpm":"BPM","noData":"No Data"}}}')
  delete Component.options._Ctor
}
